import {
    GetDomainFromEmail,
    IsDomainValid
} from "../validators/domainValidator";

/**
 * Gets organisation from email if private, if public domain use entered field
 * @param email
 * @param organisation
 * @returns
 */
export const GetUserOrganisation = (
    email: string,
    organisation: string
): string => {
    const isOrganisationDomain = IsDomainValid(email);

    if (isOrganisationDomain) {
        return GetDomainFromEmail(email);
    }

    return organisation;
};
